/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show faces</h4>

<p>Show or hide faces.</p>

<p>In case some faces are selected, hitting the icon will hide them.</p>

<p>Hitting the icon with the Shift-key pressed will hide all faces, except for the selected ones.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>R</b>: Hide faces</li>
</ul>`;

export default function IsolateFacesTooltip() {
    return h('div', { innerHTML: body });
}
